import React from 'react'
import { Spin } from 'antd'
import { useCreateUserEmotionMutation, useGetEmotionsQuery } from '../../api/v2/emotions'
import { useMyContext } from '../../context/context'
import useWebsocketV2 from '../../hooks/useWebsocketV2'

export default function UserEmotions() {
  const { myContext } = useMyContext()
  const { sequenceId } = useWebsocketV2()

  const { data: emotions } = useGetEmotionsQuery(myContext)
  const [create, { isLoading }] = useCreateUserEmotionMutation()

  if (!sequenceId) {
    return null
  }

  return (
    <Spin spinning={isLoading} size="small">
      <div style={{ display: 'flex', justifyContent: 'center', marginTop: 32 }}>
        <div style={{ display: 'flex', gap: 32, flexWrap: 'wrap', justifyContent: 'space-around' }}>
          {emotions?.map(m => (
            <img
              src={m.iconUrl}
              style={{ height: 50, cursor: 'pointer' }}
              onClick={() => create({ ...myContext, emotionId: m.id, sequenceId })}
              aria-hidden
            />
          ))}
        </div>
      </div>
    </Spin>
  )
}
